// components/integrations/shared/IntegrationHeader.tsx
import React from 'react';

interface IntegrationHeaderProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  status: string;
  statusColor?: string;
  gradientFrom?: string;
  gradientTo?: string;
}

export const IntegrationHeader: React.FC<IntegrationHeaderProps> = ({
  icon,
  title,
  description,
  status,
  statusColor = 'green',
  gradientFrom = 'blue-50',
  gradientTo = 'indigo-50',
}) => {
  return (
    <div className={`flex items-start gap-4 bg-gradient-to-r from-${gradientFrom} to-${gradientTo} border border-${gradientFrom.replace('-50', '-200')} rounded-xl p-6`}>
      {icon}
      <div className="flex-1">
        <h2 className="text-lg font-semibold text-slate-800">{title}</h2>
        <p className="text-sm text-slate-600">{description}</p>
      </div>
      <div className={`flex items-center gap-2 bg-${statusColor}-100 text-${statusColor}-700 px-3 py-1.5 rounded-full`}>
        <div className={`w-2 h-2 bg-${statusColor}-500 rounded-full animate-pulse`} />
        <span className="text-xs font-medium">{status}</span>
      </div>
    </div>
  );
};